import { render, staticRenderFns } from "./FrontMainBody.vue?vue&type=template&id=dec22082"
import script from "./FrontMainBody.vue?vue&type=script&lang=js"
export * from "./FrontMainBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports